import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { getUserType } from "util/auth";
import { StoreTargetApiParams, TargetStore } from "../types";
import getStoreDataApi from "../api/getStoreDataApi";
import getStoreDataCompanyApi from "../api/getStoreDataCompanyApi";
// import getTyreOptionsApi from "../api/getTyreOptionsApi";

/**
 * 注文対象全店舗検索hooks
 * @returns JSX.Element
 */
export default function useStoreSearch(): {
  // storeTargetApiParams: StoreTargetApiParams;
  // setStoreTargetApiParams: Dispatch<SetStateAction<StoreTargetApiParams>>;
  isLoading: boolean;
  stores: TargetStore[];
} {
  const [stores, setStores] = useState<TargetStore[]>([]);
  // const [storeTargetApiParams, setStoreTargetApiParams] = useState<StoreTargetApiParams>({
  //   clientCd: "",
  //   storeName: "",
  //   isClient: 0,
  // });
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    (async () => {
      setIsLoading(true);
      try {
        const userType = getUserType();
        if (userType === "C0006") {
          await getStoreDataCompanyApi().then((fetched) => setStores(fetched));
        } else {
          await getStoreDataApi().then((fetched) => setStores(fetched));
        }
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  return {
    isLoading,
    stores,
  };
}
